import React, { Component } from "react"
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, FormControl, FormHelperText } from "@material-ui/core"
import Save from "../../../../assets/img/svg/save.svg"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import image from "../../../../assets/img/svg/Image.svg"
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import { gethistorylogprojectdocinfo } from "../../../../actions/AddNewProjectAction"
class AddHL extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProjectId: 0,
            isMobile: false,
            menu: true,
        }
    };

    sidebar = () => {
        if (window.location.pathname == '/historylog' == true) {
            this.props.navigate("/sidebareditproject");
        }
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#History1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#HistoryLog1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#HistoryLog").removeClass("d-none");
        $("#HistoryLog").addClass("d-block");
        $("#HL .MuiListItemText-primary").addClass("fw-bolder");
        $("#HLL").addClass("active-color")
    };

    AddCancel = () => {
        this.props.navigate(`/projectlist`)
    };

    componentDidMount() {
        const { dispatch } = this.props;
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.state.ProjectId = localStorage.getItem("DashId")
        this.setState({})
        dispatch(gethistorylogprojectdocinfo(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#HL .MuiListItemText-primary").removeClass("fw-bolder")
        $("#HLL").removeClass("active-color")
    }

    render() {
        const { isEdit } = this.state;
        let { classes, getprojectid, menuToggle, projectList } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"History" + "1"} className='textNaviIcon' primary={window.location.pathname == '/historylog' ? "Edit Project" : ""} />
                                            <NavigateNextIcon id="History" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">History Log</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={() => this.AddCancel()}></i></td>
                                <td width="95%"></td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ margin: this.state.isMobile ? "" : "5px" }}>

                        <h6 className="col-12 mx-2 mt-3 ml-1"> {this.state.isMobile ? "" : "History Log"}</h6>
                        <div className={this.state.isMobile ? "row mx-0 mt-n2" : "row mx-1 px-2 mt-2"}>
                            <div className={window.innerWidth < 1200 ? "col-12" : "col-6"}>
                                <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                    <table id="Docstable" className="table border-left border-right mt-2">
                                        <thead>
                                            <tr className="">
                                                <th className="border-top border-right border-left" style={{ width: '30%', minWidth: '170px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                                <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '80px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                <th className="border-top border-right" style={{ width: '55%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontFamily: 'Segoe UI' }}>
                                            {this.props.historyLog && this.props.historyLog.map((i) => (
                                                <tr>
                                                    <td className="spandoc-td border-right border-left align-middle Nowrap">
                                                        {i.TimeStamp && moment(i.TimeStamp).format(this.props.settings.Convention ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                    </td>
                                                    <td className="spandoc-td border-right align-middle Nowrap">{i.Action}</td>
                                                    <td className="spandoc-td border-right align-middle Nowrap">{i.ActionBy}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        historyLog: state.commonReducer.historyLog || [],
        settings: state.commonReducer.settings || [],
    };
}

AddHL.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddHL))
);
